<template class="white-content">
	<div id="app">
		<div class="content">
			<notifications></notifications>
			<router-view :key="$route.fullPath"></router-view>
			<div
				v-if="$route.fullPath != '/alertas' && $route.name != 'login'"
				@click="chat()"
				id="chatWidget"
				type="warning"
				block
				class="mb-3"
			>
				<span v-if="numeroNotificacoes > 0" class="notificacao mb-2">{{
					numeroNotificacoes
				}}</span>
				<div>
					<i class="tim-icons icon-chat-33 "></i>
					<span> Alertas </span>
				</div>
			</div>
		</div>
		<modal
			:show.sync="notificacao"
			footerClasses="justify-content-center "
			type="notice"
			persistent
		>
			<div class="instruction">
				<div class="row mt-3">
					<div class="col-md-12 text-center">
						<div class="form-group text-left">
							<h2>{{ mensagem }}</h2>
						</div>
					</div>
				</div>
			</div>
			<div slot="footer" class="justify-content-center">
				<base-button type="success" simple @click="notificacao = false"
					>Percebi</base-button
				>
			</div>
		</modal>
	</div>
</template>

<script>
	import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
	import Pusher from "pusher-js";
	import api from "@/api/index";
	import { Modal } from "@/components/index";
	// Import Bootstrap and BootstrapVue CSS files (order is important)
	import "bootstrap/dist/css/bootstrap.css";
	import "bootstrap-vue/dist/bootstrap-vue.css";
	export default {
		components: {
			Modal,
		},
		data() {
			return {
				numeroNotificacoes: 0,
				mensagem: "",
				notificacao: false,
				utilizador: [],
			};
		},
		methods: {
			chat() {
				this.numeroNotificacoes = 0;
				this.$router.push("/alertas");
			},
			disableRTL() {
				if (!this.$rtl.isRTL) {
					this.$rtl.disableRTL();
				}
			},
			toggleNavOpen() {
				let root = document.getElementsByTagName("html")[0];
				root.classList.toggle("nav-open");
			},
		},
		async mounted() {
			this.$watch("$route", this.disableRTL, { immediate: true });
			this.$watch("$sidebar.showSidebar", this.toggleNavOpen);
			var _this = this;

			var user_id = localStorage.getItem("active-session-niu");
			var jsonUser = {
				user_id: user_id,
			};

			let res = await api.buscarDados(jsonUser);
			if (Object.values(res).length > 0) {
				this.utilizador = Object.values(res)[0];
			} else {
				localStorage.removeItem("active-session-niu");
				this.$router.push("/");
			}
			Pusher.logToConsole = false;

			const pusher = new Pusher("0301792fa0059f29eefc", {
				cluster: "eu",
			});

			const pusher2 = new Pusher("e00355a111abb8c58e5b", {
				cluster: "eu",
			});

			const channel = pusher.subscribe("alertas");
			channel.bind("alerta", async (data) => {
				_this.mensagem = data.mensagem;
				if (_this.utilizador.nivel != 1) {
					_this.notificacao = true;
				}
			});

			const channel2 = pusher2.subscribe("chat");
			channel2.bind("mensagem", async (data) => {
				_this.numeroNotificacoes = Number(_this.numeroNotificacoes) + 1;
			});
		},
	};
</script>

<style lang="scss">
	.form-check-input:checked[type="radio"] {
		background-image: url("/img/check.png") !important;
	}
	.form-check-input[type="radio"] {
		border-radius: 0 !important;
	}
	.form-check-input:checked {
		background-color: #fff !important;
		border-color: #6d32ff !important;
	}
	.notificacao {
		color: white;
		font-weight: bold;
		padding: 5px;
		background-color: red;
		border-radius: 50px;
	}
	#chatWidget {
		position: fixed;
		bottom: 40px;
		right: 47px;
		width: 150px;
		z-index: 999999;
		font-size: 14px;
		background: #212e3e;
		padding: 15px;
		text-align: center;
		border-radius: 10px;
		box-shadow: 3px 3px 7px #cecece;
		cursor: pointer;
	}

	#chatWidget:hover {
		background: #fff;
	}

	#chatWidget:hover span,
	#chatWidget:hover i {
		background: #fff;
		color: #212e3e;
	}

	#chatWidget span,
	#chatWidget i {
		color: #fff;
	}

	.cardGrupos {
		height: 350px !important;
		justify-content: center;
	}
	.pointer {
		cursor: pointer;
	}
	.loading-overlay {
		display: none;
		background: #666;
		position: fixed;
		bottom: 0;
		left: 0;
		right: 0;
		top: 0;
		z-index: 9998;
		align-items: center;
		justify-content: center;
		opacity: 0.5;
	}

	.loading-overlay.is-active {
		display: flex;
	}
	.navbar .navbar-brand {
		padding-top: 0 !important;
		padding-bottom: 0 !important;
	}
	.mensagemErro {
		color: red !important;
	}
	.fixed-plugin {
		display: none !important;
	}
	#app {
		// font-family: "Avenir", Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
	}

	.edp_verde {
		color: #28ff52 !important;
	}
	.edp_roxo {
		color: #6d32ff !important;
	}
	.bg_edp_verde {
		background: #28ff52 !important;
	}
	.bg_edp_roxo {
		color: #6d32ff !important;
	}
	#nav {
		padding: 30px;
		a {
			font-weight: bold;
			color: #2c3e50;
			&.router-link-exact-active {
				color: #42b983;
			}
		}
	}

	.sidebar[data="green"],
	.off-canvas-sidebar[data="green"] {
		background: #212e3e !important;
		box-shadow: 0 14px 15px 0 rgba(123, 123, 123, 0.5) !important;
		background: linear-gradient(0deg, #212e3e 0%, #212e3e 100%) !important;
	}

	.navbar .navbar-brand {
		margin-left: 0 !important;
	}

	.navbar-brand img {
		max-width: 80%;
	}

	.sidebar[data="green"]::before,
	.off-canvas-sidebar[data="green"]::before {
		border-bottom-color: #212e3e !important;
	}

	.main-panel[data="green"] {
		border-top: 2px solid #212e3e !important;
	}

	@font-face {
		font-family: "FTBase-Regular";
		src: url("assets/fonts/FTBase-Regular.eot");
		src: url("assets/fonts/FTBase-Regular.eot") format("embedded-opentype"),
			url("assets/fonts/FTBase-Regular.woff2") format("woff2"),
			url("assets/fonts/FTBase-Regular.woff") format("woff");
		font-weight: normal;
		font-style: normal;
	}

	b,
	strong {
		font-weight: bold !important;
	}

	body,
	h1,
	h2,
	h3,
	h4,
	h5,
	h6,
	p,
	a,
	ul,
	li,
	button,
	input,
	optgroup,
	select,
	textarea {
		font-family: "FTBase-Regular" !important;
	}

	.marineBg {
		background: #212e3e !important;
	}

	.marineBg * {
		color: #fff !important;
	}

	.marineBg .el-input__inner {
		border-color: #fff !important;
		color: #fff !important;
	}

	.eletricGreenBg {
		background: #28ff52 !important;
	}

	.violetPurpleBg {
		background: #6d32ff !important;
	}

	.card {
		box-shadow: 0 14px 15px 0 rgba(123, 123, 123, 0.5) !important;
	}

	* {
		border-radius: 0 !important;
	}

	.bg_edp_roxo {
		background: #212e3e !important;
		color: #fff !important;
		border: 2px solid #212e3e !important;
	}

	.bg_edp_roxo:hover,
	.bg_edp_roxo:active {
		background: #fff !important;
		color: #212e3e !important;
	}

	.bg_edp_verde,
	#upload .btn {
		background: #28ff52 !important;
		color: #000 !important;
		border: 2px solid #28ff52 !important;
	}

	.bg_edp_verde:hover,
	.bg_edp_verde:active,
	#upload .btn:hover,
	#upload .btn:active {
		background: #000 !important;
		color: #28ff52 !important;
	}

	.content .row p,
	.content .row ul,
	.content .row li,
	.btn,
	.btn-lg,
	.btn-group-lg > .btn {
		font-size: 1rem;
		text-align: left;
	}

	.navbar .navbar-wrapper {
		margin-top: 10px;
	}

	.el-table table {
		margin-bottom: 0 !important;
	}

	.sidebar .nav li > a,
	.off-canvas-sidebar .nav li > a {
		font-size: 12px !important;
	}

	.form-check-input,
	.el-tooltip.fas.fa-info-circle {
		cursor: pointer;
	}

	.modal-content {
		background: #225e66 !important;
	}
	.modal-body p,
	.modal-header h2 {
		color: #fff !important;
	}

	.modal-content p {
		font-size: 18px;
	}

	.modal-content {
		padding: 20px !important;
	}

	.modal.show {
		background-color: rgba(0, 0, 0, 0.8);
	}

	.marineBg .el-input__inner::placeholder {
		color: #fff !important;
	}

	.instruction label {
		color: #fff;
	}

	.form-check-input {
		width: 2em;
		height: 2em;
		position: relative !important;
	}

	.el-tooltip.fas.fa-info-circle {
		font-size: 20px !important;
	}

	.swal2-popup {
		background: #225e66 !important;
	}

	#swal2-content {
		color: #fff;
	}

	.swal2-confirm.btn.btn-success.btn-fill,
	.swal2-confirm.btn.btn-success.btn-fill:hover {
		background: #fff !important;
		color: #225e66 !important;
	}

	.swal2-cancel.btn.btn-danger.btn-fill,
	.swal2-cancel.btn.btn-danger.btn-fill:hover {
		background: #f00 !important;
	}

	.select-info.el-select .el-input input {
		border-width: 2px !important;
		border-color: #212e3e !important;
		color: #212e3e !important;
	}

	.select-info.el-select-dropdown__item.selected,
	.select-info.el-select-dropdown__item.selected.hover {
		background-color: #212e3e !important;
		color: white;
	}

	.modal-content .modal-header i.tim-icons {
		font-size: 16px;
		color: #fff;
	}

	.modal-body .form-control {
		color: #fff;
	}
	.login-page .form-control {
		font-size: 1rem;
		height: calc(3rem + 2px);
	}
	.login-page {
		background: #212e3e !important;
	}

	* {
		word-break: normal !important;
	}

	.instruction h2 {
		color: #fff;
	}
	y .mobile {
		display: none !important;
	}
	.desktop {
		display: block !important;
	}
	@media only screen and (max-width: 800px) {
		.navbar .navbar-wrapper {
			display: flex;
			width: 100%;
			margin: auto;
			align-content: center;
			align-items: center;
			justify-content: center;
		}
		.navbar .text-right {
			text-align: center !important;
			width: 100%;
		}
		.main-panel > .content {
			padding-top: 100px !important;
		}
		.marineBg .bg_edp_verde {
			margin: auto;
		}
		.el-select-dropdown.el-popper {
			width: 100%;
			left: 0 !important;
		}
		.progress-container.progress-default.progress-sm {
			width: 50px !important;
		}
		.progress {
			display: none !important;
		}
		.mobile {
			display: block !important;
		}
		.desktop {
			display: none !important;
		}
		.homepage .marineBg .pl-5 {
			padding-left: 0 !important;
		}
		.homepage .marineBg .pr-5 {
			padding-right: 0 !important;
		}
		.homepage .marineBg .p-5 {
			padding-left: 0 !important;
			padding-right: 0 !important;
		}
		.row.passos .col {
			width: 100vw !important;
		}
		.cardGrupos .descTribo {
			font-size: 12px !important;
		}
		.homepage .marineBg h3 {
			font-size: 16px;
		}
		.cardGrupos {
			justify-content: start;
			height: 98% !important;
		}
		.table > thead > tr > th,
		.el-table table > thead > tr > th {
			font-size: 8px !important;
		}
		.el-tooltip__popper.is-dark {
			background: #303133;
			color: #fff;
			max-width: 80vw;
			margin: auto;
		}
	}
</style>
